import { render, staticRenderFns } from "./LinkedDriversTrips.vue?vue&type=template&id=6232de7a&"
import script from "./LinkedDriversTrips.vue?vue&type=script&lang=js&"
export * from "./LinkedDriversTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports